<div id="header-search">
  @if (isNarrow) {
    <div
      id="header-search-input-container-narrow"
      data-cy="exx-header-searchbar-mobile"
      #searchInputContainer
      class="fx-row fx-row-v-center fx-row-h-right"
      >
      <mat-icon svgIcon="nav-search" (click)="searchClicked()"></mat-icon>
      <input
        class="header-search-input"
        #searchInput
        id="search-icon"
        [class.no-focus-ring]="hideFocusRing"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (keyup)="onKeyup($event)"
        (keydown.enter)="onKeydownEnter()"
        />
    </div>
  } @else {
    <div
      id="header-search-input-container-wide"
      data-cy="exx-header-searchbar-desktop"
      #searchInputContainer
      >
      <input
        class="header-search-input"
        #searchInput
        placeholder="Search"
        [class.mat-elevation-z2]="searchInputHasFocus"
        (focus)="onFocus()"
        (keyup)="onKeyup($event)"
        (keydown.enter)="onKeydownEnter()"
        />
      <mat-icon
        class="search"
        (click)="onClickSearch()"
        svgIcon="nav-search"
      ></mat-icon>
    </div>
  }

  @if (isActive || (isNarrow && searchInputHasFocus)) {
    <div
      id="header-search-menu"
      #searchMenu
      [class.initial-bg]="initialSearch"
      >
      @if (
        !initialSearch && isSearching && suggested.products.length == 0
        ) {
        <div
          >
          <h5 class="header-search-menu-title">Searching...</h5>
        </div>
      }
      @if (
        !initialSearch && !isSearching && suggested.products.length == 0
        ) {
        <div
          >
          <h5 class="header-search-menu-title" #noResultsDisplay>
            No results match your search query.
          </h5>
        </div>
      }
      @if (suggested.terms.length > 0) {
        <div
          id="header-search-menu-terms"
          #searchMenuTerms
          >
          <div id="header-search-menu-terms-links">
            @for (term of suggested.terms; track term) {
              <div
                class="term"
                >
                <a
                  routerLink="/category/search"
                  [queryParams]="{ q: term?.queryParams?.q, page: 1 }"
                  (click)="setIsActive()"
                  ><span class="term-inner truncate-ellipsis" [innerHTML]="term.text"></span
                ></a>
              </div>
            }
          </div>
        </div>
      }
      @if (suggested.products.length > 0) {
        <div
          id="header-search-menu-products"
          >
          @for (product of suggested.products; track product) {
            <div
              class="header-search-menu-products-links"
              >
              <a
                class="fx-col fx-col-h-left fx-col-v-center fx-wrap"
                [routerLink]="product.urlComponent"
                (click)="setIsActive()"
                >
                <div class="product-link-inner fx-row fx-row-h-left fx-row-v-center">
                  <div class="header-search-menu-product-image">
                    @if (product?.imageUrl) {
                      <img
                        [src]="getWebpImg(product.imageUrl)"
                        [alt]="product.title"
                        />
                    }
                  </div>
                  <div class="fx-col">
                    <span
                      class="truncate-ellipsis pl-3"
                      [innerHTML]="product.name"
                    ></span>
                    <span class="pl-3 pt-2 mpn-display"
                      >MPN: {{ product?.mpn }}</span
                      >
                    </div>
                  </div>
                </a>
              </div>
            }
          </div>
        }
        @if (suggested.products.length > 0) {
          <div
            id="header-search-menu-see-more-results"
            #searchSeeMore
            >
            <a role="link"
              id="header-search-menu-see-more-results-link"
              tabindex="0"
              (click)="setIsActive()"
              (keydown.enter)="onSearchClickResults()"
              >
              <div class="see-more-inner fx-row fx-row-v-center fx-row-h-space-between">
                <div (click)="onSearchClickResults()">
                  <span class="bold pr-1">View All</span>
                  <span class="total-results"
                    >({{ suggested.total }} items)</span
                    >
                  </div>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </a>
            </div>
          }
        </div>
      }
    </div>
